import { useEffect, useState } from 'react';
import style from './block.module.scss';

const Block = () => {
    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        window.addEventListener('scroll', scrollListener);

        return () => window.removeEventListener('scroll', scrollListener);
    });

    const scrollListener = (e) => {
        setScroll(
            ((document.documentElement.scrollTop + document.body.scrollTop) /
                (document.documentElement.scrollHeight - document.documentElement.clientHeight)) *
                100,
        );
    };

    return (
        <div className={style.block}>
            <div className={style.gauge} style={{ width: scroll + '%' }} />
        </div>
    );
};

export default Block;
